var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMultiStep = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 38,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "multi_step_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 53,
  height: 38
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FC",
  d: "M0 0h53v37.857H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#multi_step_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FC",
  d: "M0 0h53v37.857H0z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.086,
  y: 6.055,
  width: 34.829,
  height: 25.743,
  rx: 2,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 16.908,
  y: 10.09,
  width: 19.186,
  height: 2.529,
  rx: 1.264,
  stroke: "#000866",
  strokeOpacity: 0.2,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 16.908,
  y: 14.09,
  width: 19.186,
  height: 2.529,
  rx: 1.264,
  stroke: "#000866",
  strokeOpacity: 0.2,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 16.908,
  y: 18.09,
  width: 19.186,
  height: 2.529,
  rx: 1.264,
  stroke: "#000866",
  strokeOpacity: 0.2,
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  x: 18.93,
  y: 24.984,
  width: 15.143,
  height: 3.029,
  rx: 1.514,
  fill: "#038AFF"
}))));
export { SvgMultiStep as ReactComponent };
export default __webpack_public_path__ + "images/multi_step.svg";